import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getHotelStatic } from 'src/api/hotelApi';
import TopNavbar from 'src/components/admin/navigation/topNav';
import Footer from 'src/components/Footer';
import ScrollTop from 'src/components/ScrollTop';
import { hotelAction } from 'src/redux/actions';
import { propsBasicLayoutType } from 'utils/proptypes';

const UserLayout = (props: propsBasicLayoutType) => {
   const { children } = props;

   const dispatch = useDispatch();

   const { data } = useQuery({
      queryKey: ['getHotelStatic'],
      queryFn: getHotelStatic,
      retry: false,
      staleTime: Infinity,
   });

   useEffect(() => {
      if (data?.data) {
         dispatch(hotelAction.setHotelStatic(data?.data));
      }
   }, [data?.data]);

   return (
      <div className="flex flex-col w-full h-screen bg-cover bg-center">
         <ScrollTop />
         {/* Navigation bar */}
         <TopNavbar darkMode={true} className="bg-primary shadow-[1px_1px_10px_-1px_#00000033]" />

         {/* Body content */}
         <div className="flex w-full flex-1 justify-center p-3.75 sm:p-7.5 bg-white">{children}</div>

         {/* Footer */}
         <Footer />
      </div>
   );
};

export default UserLayout;
